import styled from 'styled-components';

export const ExploreProductsPage = styled.div`
  width: 100%;
`;

export const HeroSection = styled.section`
  width: 100%;

  padding-bottom: var(--space-xxxl);
`;

export const HeroContainer = styled.div`
  width: min(100%, 1280px);

  margin: 0 auto;
`;

export const HeroGrid = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1.05fr) minmax(360px, 0.75fr);
  align-items: center;
  gap: clamp(var(--space-xxl), 6vw, var(--space-xxxxxl));

  @media screen and (max-width: 1000px) {
    grid-template-columns: 1fr;
    gap: var(--space-xxxl);
  }
`;

export const HeroContent = styled.div`
  width: 100%;
  max-width: 760px;
`;

export const HeroEyebrow = styled.p`
  margin: 0 0 var(--space-s);

  color: var(--orange5);

  font-family: var(--mainFont);
  font-size: 0.76rem;
  line-height: 1.4;
  font-weight: 800;

  text-transform: uppercase;
  letter-spacing: 0.15em;
`;

export const HeroTitle = styled.h1`
  max-width: 820px;

  margin: 0;

  color: var(--grey7);

  font-size: clamp(2.8rem, 5.2vw, 5rem);
  line-height: 0.98;
  font-weight: 800;

  letter-spacing: -0.05em;

  @media screen and (max-width: 650px) {
    font-size: clamp(2.45rem, 12vw, 3.8rem);
    line-height: 1;
  }
`;

export const HeroDescription = styled.p`
  max-width: 680px;

  margin: var(--space-xl) 0 0;

  color: var(--grey4);

  font-family: var(--mainFont);
  font-size: clamp(1rem, 1.4vw, 1.08rem);
  line-height: 1.8;
  font-weight: 500;

  @media screen and (max-width: 650px) {
    margin-top: var(--space-l);

    line-height: 1.7;
  }
`;

export const HeroActions = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--space-s);

  margin-top: var(--space-xl);

  @media screen and (max-width: 520px) {
    align-items: stretch;
    flex-direction: column;
  }
`;

export const PrimaryAction = styled.button`
  min-height: 46px;

  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: var(--space-s);

  padding: var(--space-s) var(--space-l);

  border: 1px solid var(--yellow5);
  border-radius: var(--borderRadiusButton);

  background: var(--yellow5);

  color: var(--grey7);

  font-family: var(--mainFont);
  font-size: 0.86rem;
  line-height: 1;
  font-weight: 800;

  text-decoration: none;

  cursor: pointer;

  transition:
    background-color 180ms ease,
    border-color 180ms ease,
    transform 180ms ease;

  svg {
    flex-shrink: 0;
  }

  &:hover {
    border-color: var(--orange2);

    background: var(--yellow4);

    transform: translateY(-1px);
  }

  &:focus-visible {
    outline: 2px solid var(--orange5);
    outline-offset: 3px;
  }
`;

export const SecondaryAction = styled.button`
  min-height: 46px;

  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: var(--space-s);

  padding: var(--space-s) var(--space-l);

  border: 1px solid var(--grey);
  border-radius: var(--borderRadiusButton);

  background: var(--white);

  color: var(--grey7);

  font-family: var(--mainFont);
  font-size: 0.86rem;
  line-height: 1;
  font-weight: 800;

  text-decoration: none;

  cursor: pointer;

  transition:
    background-color 180ms ease,
    border-color 180ms ease,
    transform 180ms ease;

  &:hover {
    border-color: var(--orange1);

    background: var(--yellow1);

    transform: translateY(-1px);
  }

  &:focus-visible {
    outline: 2px solid var(--orange5);
    outline-offset: 3px;
  }
`;

export const OrderPanel = styled.aside`
  width: 100%;

  padding: var(--space-l);

  border: 1px solid var(--grey);
  border-radius: var(--borderRadiusLarge);

  background: var(--white);

  box-shadow:
    0 22px 58px rgba(23, 23, 23, 0.075),
    0 3px 10px rgba(23, 23, 23, 0.025);

  @media screen and (max-width: 1000px) {
    max-width: 700px;
  }
`;

export const OrderPanelHeader = styled.div`
  display: flex;
  align-items: flex-start;
  gap: var(--space-m);
`;

export const OrderPanelIcon = styled.span`
  width: 46px;
  height: 46px;

  flex-shrink: 0;

  display: grid;
  place-items: center;

  border: 1px solid rgba(230, 139, 7, 0.18);
  border-radius: var(--borderRadius);

  background: var(--yellow1);

  color: var(--orange5);

  font-size: 1rem;
  line-height: 0;

  svg {
    width: 18px;
    height: 18px;

    display: block;
  }
`;

export const OrderPanelEyebrow = styled.p`
  margin: 0 0 var(--space-xxs);

  color: var(--orange5);

  font-family: var(--mainFont);
  font-size: 0.67rem;
  line-height: 1.4;
  font-weight: 800;

  text-transform: uppercase;
  letter-spacing: 0.12em;
`;

export const OrderPanelTitle = styled.h2`
  margin: 0;

  color: var(--grey7);

  font-size: clamp(1.45rem, 2.3vw, 1.95rem);
  line-height: 1.05;
  font-weight: 800;

  letter-spacing: -0.035em;
`;

export const OrderPanelDescription = styled.p`
  margin: var(--space-m) 0 0;

  color: var(--grey4);

  font-family: var(--mainFont);
  font-size: 0.87rem;
  line-height: 1.65;
  font-weight: 500;
`;

export const OrderSteps = styled.div`
  display: flex;
  flex-direction: column;

  margin-top: var(--space-l);
`;

export const OrderStep = styled.div`
  display: grid;
  grid-template-columns: auto minmax(0, 1fr);
  gap: var(--space-s);

  padding: var(--space-m) 0;

  border-top: 1px solid var(--grey15);

  &:first-child {
    border-top: 0;
    padding-top: 0;
  }
`;

export const OrderStepNumber = styled.span`
  width: 30px;
  height: 30px;

  display: grid;
  place-items: center;

  border-radius: 50%;

  background: var(--yellow1);

  color: var(--orange5);

  font-family: var(--mainFont);
  font-size: 0.68rem;
  line-height: 1;
  font-weight: 800;
`;

export const OrderStepContent = styled.div`
  min-width: 0;
`;

export const OrderStepTitle = styled.h3`
  margin: 0;

  color: var(--grey7);

  font-size: 0.85rem;
  line-height: 1.35;
  font-weight: 800;
`;

export const OrderStepText = styled.p`
  margin: var(--space-xxs) 0 0;

  color: var(--grey4);

  font-size: 0.76rem;
  line-height: 1.55;
  font-weight: 500;
`;

export const OrderPanelFooter = styled.div`
  margin-top: var(--space-m);
  padding-top: var(--space-m);

  border-top: 1px solid var(--grey15);
`;

export const OrderContactLink = styled.button`
  width: 100%;

  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--space-s);

  padding: var(--space-s) var(--space-m);

  border: 1px solid var(--grey7);
  border-radius: var(--borderRadiusButton);

  background: var(--grey7);

  color: var(--white);

  font-family: var(--mainFont);
  font-size: 0.82rem;
  line-height: 1;
  font-weight: 800;

  cursor: pointer;

  transition:
    background-color 180ms ease,
    transform 180ms ease;

  svg:last-child {
    margin-left: auto;
  }

  &:hover {
    background: var(--grey6);

    transform: translateY(-1px);
  }
`;

export const CatalogSection = styled.section`
  width: min(100%, 1280px);

  margin: 0 auto;
  padding-bottom: var(--space-xxxxl);

  scroll-margin-top: var(--space-xl);
`;

export const CatalogHeader = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: var(--space-xl);

  margin-bottom: var(--space-xl);

  @media screen and (max-width: 700px) {
    align-items: flex-start;
    flex-direction: column;
    gap: var(--space-m);
  }
`;

export const CatalogHeadingGroup = styled.div`
  max-width: 720px;
`;

export const CatalogTitle = styled.h2`
  margin: 0;

  color: var(--grey7);

  font-size: clamp(2rem, 4vw, 3.3rem);
  line-height: 1;
  font-weight: 800;

  letter-spacing: -0.04em;
`;

export const CatalogDescription = styled.p`
  max-width: 680px;

  margin: var(--space-m) 0 0;

  color: var(--grey4);

  font-size: 0.96rem;
  line-height: 1.7;
  font-weight: 500;
`;

export const ProductCount = styled.span`
  flex-shrink: 0;

  padding: var(--space-xs) var(--space-s);

  border: 1px solid var(--grey);
  border-radius: var(--borderRadiusButton);

  background: var(--cardBackground);

  color: var(--grey4);

  font-size: 0.78rem;
  line-height: 1;
  font-weight: 700;
`;

export const CatalogControls = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(230px, 0.3fr);
  gap: var(--space-m);

  margin-bottom: var(--space-xl);

  @media screen and (max-width: 750px) {
    grid-template-columns: 1fr;
  }
`;

export const SearchBox = styled.div`
  min-height: 48px;

  display: grid;
  grid-template-columns: auto minmax(0, 1fr) auto;
  align-items: center;
  gap: 8px;

  padding: var(--space-xs) var(--space-s);

  border: 1px solid var(--grey15);
  border-radius: 10px;

  background: linear-gradient(180deg, var(--white), #fbfbfb);

  transition:
    border-color 160ms ease,
    box-shadow 160ms ease,
    transform 160ms ease;

  &:focus-within {
    border-color: rgba(230, 139, 7, 0.42);

    box-shadow: 0 6px 20px rgba(23, 23, 23, 0.06);
    transform: translateY(-1px);
  }
`;

export const SearchIcon = styled.span`
  display: grid;
  place-items: center;

  color: var(--grey4);

  line-height: 0;

  svg {
    display: block;
    width: 18px;
    height: 18px;
  }
`;

export const SearchInput = styled.input`
  width: 100%;
  min-width: 0;

  padding: 10px var(--space-s);

  border: 0;
  outline: 0;

  background: transparent;

  color: var(--grey7);

  font-family: var(--mainFont);
  font-size: 0.9rem;
  line-height: 1.25;
  font-weight: 600;

  appearance: none;

  &::placeholder {
    color: var(--grey3);
    opacity: 0.95;
  }

  &::-webkit-search-cancel-button {
    display: none;
  }
`;

export const ClearSearchButton = styled.button`
  width: 34px;
  height: 34px;

  display: grid;
  place-items: center;

  padding: 0;

  border: 0;
  border-radius: 8px;

  background: transparent;

  color: var(--grey4);

  cursor: pointer;

  transition:
    background-color 120ms ease,
    color 120ms ease,
    transform 120ms ease;

  &:hover {
    background: var(--grey15);
    color: var(--grey7);
    transform: translateY(-1px);
  }
`;

export const CategoryFilterWrap = styled.div`
  position: relative;

  display: flex;
  align-items: center;
`;

export const CategorySelect = styled.select`
  width: 100%;
  min-height: 48px;

  /* reserve space on the right for the dropdown icon */
  padding: 0 44px 0 var(--space-m);

  border: 1px solid var(--grey15);
  border-radius: var(--borderRadius);

  background: var(--white);

  color: var(--grey6);

  font-family: var(--mainFont);
  font-size: 0.86rem;
  line-height: 1.25;
  font-weight: 700;

  outline: 0;
  appearance: none;

  cursor: pointer;

  &:focus {
    border-color: rgba(230, 139, 7, 0.42);

    box-shadow: 0 6px 18px rgba(23, 23, 23, 0.06);
  }
`;
export const StateCard = styled.div`
  width: 100%;
  min-height: 280px;

  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: var(--space-s);

  padding: var(--space-xl);

  border: 1px solid var(--grey);
  border-radius: var(--borderRadiusLarge);

  background: var(--cardBackground);

  text-align: center;
`;

export const StateIcon = styled.span`
  width: 48px;
  height: 48px;

  display: grid;
  place-items: center;

  border-radius: 50%;

  background: var(--yellow1);

  color: var(--orange5);

  font-size: 1.05rem;
`;

export const StateTitle = styled.h3`
  margin: var(--space-xs) 0 0;

  color: var(--grey7);

  font-size: 1.2rem;
  line-height: 1.3;
  font-weight: 800;
`;

export const StateDescription = styled.p`
  max-width: 520px;

  margin: 0;

  color: var(--grey4);

  font-size: 0.88rem;
  line-height: 1.65;
  font-weight: 500;
`;
export const ContactBanner = styled.section`
  width: min(100%, 1280px);

  margin: 0 auto;
  padding-bottom: var(--space-xxxxl);
`;

export const ContactBannerContent = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  align-items: center;
  gap: var(--space-xl);

  padding: var(--space-xl);

  border: 1px solid rgba(230, 139, 7, 0.18);
  border-radius: var(--borderRadiusLarge);

  background: rgba(255, 240, 194, 0.45);

  @media screen and (max-width: 850px) {
    grid-template-columns: 1fr;
  }
`;

export const ContactBannerEyebrow = styled.p`
  margin: 0 0 var(--space-xs);

  color: var(--orange5);

  font-size: 0.7rem;
  line-height: 1.4;
  font-weight: 800;

  text-transform: uppercase;
  letter-spacing: 0.12em;
`;

export const ContactBannerTitle = styled.h2`
  margin: 0;

  color: var(--grey7);

  font-size: clamp(1.6rem, 3vw, 2.35rem);
  line-height: 1.08;
  font-weight: 800;

  letter-spacing: -0.035em;
`;

export const ContactBannerDescription = styled.p`
  max-width: 760px;

  margin: var(--space-s) 0 0;

  color: var(--grey4);

  font-size: 0.88rem;
  line-height: 1.65;
  font-weight: 500;
`;

export const ContactBannerActions = styled.div`
  display: flex;
  align-items: center;
  gap: var(--space-s);

  @media screen and (max-width: 520px) {
    align-items: stretch;
    flex-direction: column;
  }
`;

/* Pagination controls */
export const PaginationControls = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 1rem;
`;

export const PageGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const PageButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;

  padding: 8px 12px;
  border-radius: 8px;

  border: 1px solid var(--grey15);
  background: var(--white);
  color: var(--grey7);

  font-weight: 800;
  cursor: pointer;

  transition:
    transform 160ms ease,
    box-shadow 160ms ease,
    background-color 160ms ease;

  &:hover:not(:disabled) {
    transform: translateY(-2px);
    box-shadow: 0 6px 18px rgba(23, 23, 23, 0.06);
  }

  &:disabled {
    opacity: 0.5;
    cursor: default;
    transform: none;
    box-shadow: none;
  }
`;

export const PageInfo = styled.span`
  margin-left: 12px;
  color: var(--grey5);
  font-weight: 700;
`;

export const PageSizeSelect = styled.select`
  padding: 6px 8px;
  border-radius: 6px;
  border: 1px solid var(--grey15);
  background: var(--white);
  color: var(--grey7);
  font-weight: 700;
`;
